interface MonthNameProperties {
  timestamp: string; // ISO string, UNIX timestamp, or Date object
  format?: 'long' | 'short'; // optional: January vs Jan
}

/**
 * Component for extracting month name
 */
function GetMonthName({ timestamp, format = 'long' }: MonthNameProperties) {
  const date = new Date(timestamp);

  if (Number.isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  return date.toLocaleString('en-US', { month: format });
}

export default GetMonthName;

GetMonthName.defaultProps = {
  format: 'long',
};
